import {
  Adapter,
  Country,
  CountryConfig,
  Currency,
  IAdapter,
  ICountry,
  ICountryConfig,
  ICountryConfigResponse,
  ICurrencyData,
  IUser,
  UserDetail,
} from "@/entities";
import { IPageResponse } from "@/services";
import { Store } from "vuex";
import { IState, Locale } from "../store.types";
import { IGetters } from "@/store";
import { ISolCustomerCurrency } from "@/entities/sol_customer/currency/currency.types";
import { SolCustomerCurrency } from "@/entities/sol_customer/currency";

export const getters: IGetters = {
  getLocale(state: IState): Locale {
    return state.locale;
  },
  getCurrentLocation(state: IState): string {
    return state.currentLocation;
  },
  getSignedIn(state: IState): boolean {
    return state.signedIn;
  },
  getLoggedUser(this: Store<IState>, state: IState): IUser | undefined {
    if (!state.loggedUser) {
      return;
    }

    return new UserDetail(state.loggedUser);
  },
  getDisclaimer(this: Store<IState>, state: IState): string | undefined {
    return state.disclaimer;
  },
  getUsersGuide(this: Store<IState>, state: IState): string | undefined {
    return state.usersGuide;
  },
  getCountryConfig(this: Store<IState>, state: IState): ICountryConfig | undefined {
    if (!state.countryConfig) {
      return;
    }
    return new CountryConfig(state.countryConfig);
  },
  getCashCountryConfig(state: IState): ICountryConfigResponse | undefined {
    return state.cashCountryConfig;
  },
  getCountriesPage(state: IState): IPageResponse<ICountry> | undefined {
    if (!state.countriesPage) {
      return;
    }

    const resultPage = state.countriesPage;

    resultPage.content = resultPage.content.map((data) => new Country(data));

    return resultPage;
  },
  getAssignableAdapters(state: IState): IAdapter[] {
    return state.assignableAdapters.map((data) => new Adapter(data));
  },
  getCurrenciesPage(state: IState): IPageResponse<ICurrencyData> | undefined {
    if (!state.currenciesPage) {
      return;
    }

    const resultPage = state.currenciesPage;

    resultPage.content = resultPage.content.map((data) => new Currency(data));

    return resultPage;
  },
  getSolCustomerCurrencies(state: IState): ISolCustomerCurrency[] | undefined {
    return state.solCustomerCurrencies?.map((data) => new SolCustomerCurrency(data));
  },
};
